import { AsyncActionState, IAsyncAction } from './async-action'

export interface IReducersMap<T> {
  [key: string]: (state: T, action) => T
}

export type ActionState<T, TState, TAction extends IAsyncAction<T>> = (
  state: TState,
  action: TAction,
) => TState

export function createAsyncReducer<T, TState, TAction extends IAsyncAction<T>>(
  initialState: TState,
  initial: ActionState<T, TState, TAction>,
  success: ActionState<T, TState, TAction>,
  failure: ActionState<T, TState, TAction> = (state) => state,
  reset: ActionState<T, TState, TAction> = (state) => state,
  remove: ActionState<T, TState, TAction> = (state) => state,
) {
  return (state: TState = initialState, action: TAction): TState => {
    switch (action.status) {
      case AsyncActionState.Initiated:
        return initial(state, action)

      case AsyncActionState.Success:
        return success(state, action)

      case AsyncActionState.Failure:
        return failure(state, action)

      case AsyncActionState.NotStarted:
        return reset(state, action)

      case AsyncActionState.Discrepancy:
        return failure(state, action)

      case AsyncActionState.Remove:
        return remove(state, action)

      default:
        return state
    }
  }
}

export function reducer<TState, TAction extends { type: string }>(
  map: IReducersMap<TState>,
  initialState: TState,
) {
  return (state: TState = initialState, action: TAction): TState => {
    const mappedReducer = map[action.type]

    return mappedReducer ? mappedReducer(state, action) : state
  }
}
